import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Logo from "../../assets/logo.svg";
import Logotext from "../../assets/logoText.svg";
import WhiteArrow from "../../assets/backArrow.svg";
import { useLoginMutation } from '../../service/apiSlices/authSlice';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
import TextWithHTML from '../TextWithHTML/TextWIthHTML';
import { showErrorToast, showSuccessToast } from '../../utilities/toastUtils';

const LoginForm: React.FC = () => {
    const { t } = useTranslation("common");
    const initialValues = { email: '', captcha: '' };
    const [pageType, setPageType] = useState<string>("");
    const siteKey: string = process.env.REACT_APP_BASE_RECAPTCHA_SITE_KEY || "6Ld5i1EpAAAAAG-xbIm90nQzMsMEWUIy7YjNnSy9";
    const validationSchema = Yup.object({
        email: Yup.string().email(`${t('login.form.validation.email')}`).required(`${t('login.form.required.email')}`),
        captcha: Yup.string().required(`${t('login.form.required.captcha')}`),
    });

    const [loginApi] = useLoginMutation();

    const onSubmit = (values: typeof initialValues) => {
        let loginPayload = {
            email: values.email
        }
        loginApi(loginPayload).unwrap().then((response: any) => {
            if (response?.status_code === 200) {
                showSuccessToast(response.message);
                // navigate(ROUTES.VERIFY_LOGIN);
                setPageType("sent");
            }
        }).catch((error: any) => {
            showErrorToast(error?.response?.data?.message);
        });
    };

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit} >
            {({ isSubmitting, setFieldValue }) => (
                <Form className="form-container">
                    {pageType === "" ?
                        <>
                            <div className='d-flex align-items-center gap-2'>
                                <img src={Logo} alt='logo' className='' />
                                <img src={Logotext} alt='Logotext' className='' />
                            </div>
                            <p className="mb-5 mt-3 text-white interFont fw-normal lineheight27"><TextWithHTML content={t('login.loginTagText')} /></p>
                            <div className="mb-3">
                                <Field
                                    name="email"
                                    type="email"
                                    className="emailInput"
                                    placeholder={t('login.form.emailPlaceholder')}
                                />
                                <ErrorMessage name="email" component="div" className="text-danger error-msg interFont" />
                            </div>
                            <div className="mb-3">
                                <ReCAPTCHA
                                    sitekey={siteKey}
                                    onChange={(value: any) => {
                                        setFieldValue('captcha', value)
                                    }}
                                    className='loginCaptcha'
                                    size='normal'
                                    theme='dark'
                                />
                                <ErrorMessage name="captcha" component="div" className="text-danger error-msg interFont captchaError" />
                            </div>
                            <button type="submit" className="btn mt-3 btn-light w-100 fw-bold loginBtn interFont" disabled={isSubmitting}>
                                {t('login.form.button.magicLink')}
                            </button></>
                        :
                        <>
                            <div className='d-flex absolute backArrowSection gap-2 cursor-pointer'>
                                <img src={WhiteArrow} alt='WhiteArrow' className='' onClick={() => setPageType("")} />
                                <p className='interFont fw-bold backtext mb-0'>{t('buttons.back')}</p>
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <img src={Logo} alt='logo' className='' />
                                <img src={Logotext} alt='Logotext' className='' />
                            </div>
                            <p className='magiclinktext fw-bold interFont mt-4'>{t("login.success")}</p>
                            <p className='interFont magiclinkDes fst-italic fw-normal'>{t("login.subContent")}</p>
                        </>
                    }
                </Form>
            )
            }
        </Formik >
    );
};

export default LoginForm;

